module.exports = __webpack_public_path__ + "static/media/template2.7e9dfd9b.webp";